<template>
  <v-bottom-sheet
    v-model="toggle"
    scrollable
    :fullscreen="fullscreen"
  >
    <v-card 
      id="referrals" 
      class="sheet rounded-lg pt-4"
      dark
    >
      <div>
        <v-toolbar
          :elevation="toolbarElevation"
          color="transparent"
          class="page-header"
        >
          <v-expand-x-transition>
            <v-btn
              v-if="view.fullscreen"
              icon
              @click.stop="close"
            >
              <v-icon>{{ icons.mdiClose }}</v-icon>
            </v-btn>
          </v-expand-x-transition>
          <v-spacer />
          <v-toolbar-title class="title text-body-1">
            {{ $t('referrals.title') }}
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-progress-circular
              v-if="view.loading"
              color="white"
              class="loading mt-4"
              indeterminate
              size="24"
              width="2"
            />
            <v-btn
              v-else
              @click.stop="toggleHelp(true, 'referrals')"
              icon
              class="mr-n3"
            >
              <v-icon v-text="icons.mdiHelpCircleOutline" />
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </div>

      <v-card-text
        v-if="!isEmpty"
        id="referrals-scroll"
        class="content pb-12 px-0"
        v-scroll:#referrals-scroll="onScroll"
        ref="content"
      >
        <div
          v-for="section in items"
          :key="section.title"
          class="section mb-4"
        >
          <v-subheader v-if="section.items.length>0">
            {{ section.title }}
          </v-subheader>

          <v-card 
            v-for="item in section.items"
            :key="item.name"
            elevation="1" 
            class="card mx-4"
            dark
          >
            <v-card-title class="name subtitle-1 text-truncate">
              {{ item.name }}
            </v-card-title>
            <span v-if="item.status=='ACT'||item.status=='REA'">
              <span class="progress-text subtitle-2 primary--text">
                {{ progressCycles(item.progress)+1 }}&ordm; mês
                <!-- quinzena<span v-if="item.progress<1||item.progress>=2">s</span> -->
              </span>
              <div class="progress-bars d-flex pb-6">
                <v-progress-linear
                  v-for="i in 4"
                  :key="i"
                  color="primary"
                  background-color="grey lighten-2"
                  stream
                  :buffer-value="currentCycle(item.progress,i)"
                  :value="completeCycle(item.progress,i)"
                  class="progress-bar-cycle"
                />
              </div>
            </span>
            <span 
              v-else
              class="progress-text subtitle-2 grey--text"
            >
              {{ $t('referrals.waiting') }}
            </span>
          </v-card>
        </div>
      </v-card-text>
      <div
        v-else
        class="empty-state d-flex flex-column justify-center flex-grow-1 text-center px-8 py-8" 
      >
        <img 
          class="empty-icon mx-auto"
          src="/img/empty-referrals.svg"
        >
        <h4 class="title text-h6 mt-12">
          {{ $t('referrals.subtitle') }}
        </h4>
        <p 
          class="text text-body-2 text--secondary my-6"
          v-html="formatText($t('referrals.text'))"
        />
      </div>

      <v-fab-transition>
        <v-btn
          color="primary"
          dark
          absolute
          bottom
          right
          fab
          class="btn add black--text"
          @click.stop="addReferral"
        >
          <v-icon class="icon">
            {{ icons.add }}
          </v-icon>
        </v-btn>
      </v-fab-transition>
    </v-card>

    <!-- TODO Make Component -->
    <v-dialog
      v-model="dialog.toggle"
      max-width="290"
    >
      <v-card>
        <v-card-title class="text-h6">
          {{ $t(dialog.headline) }}
        </v-card-title>

        <v-card-text 
          class="referral-share text-body-1"
          v-html="formatText($t(dialog.text, { url: referralURL }))" 
        />
        
        <v-card-actions
          class="py-4"
        >
          <v-btn
            text
            @click="addReferral(false)"
          >
            {{ $t('general.back') }}
          </v-btn>
          <v-spacer />
          <v-btn
            text
            @click="copyReferralURL()"
          >
            {{ $t('general.copy') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-bottom-sheet>
</template>

<style type="text/css">

  .loading {
    opacity: .5;
  }

  #referrals .v-toolbar {
    z-index: 1;
  }

  #referrals .section .card {
    margin-bottom: 16px;
  }

  #referrals .section .card .name {
    display: block;
    max-width: 60%;
  }

  #referrals .section .card .progress-text {
    position: absolute;
    top: 16px;
    right: 16px;
    margin: 2px;
  }

  #referrals .empty-state .text {
    opacity: .75;
  }

  #referrals .progress-bars {
    padding: 0 16px 16px;
    margin-top: -4px;
  }

  #referrals .progress-bar-cycle {
    margin: 0 2px;
  }

  #referrals .btn.add {
    bottom: 1rem !important;
  }

  .referral-share a {
    max-width: 100%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
</style>

<script>
  // Icons
  import { mdiHelpCircleOutline, mdiClose, mdiPlus } from '@mdi/js';

  // Utilities
  import services from '@/services.js'
  import { sync, get } from 'vuex-pathify'
  import { Scroll } from 'vuetify/lib/directives';
  import { Capacitor } from '@capacitor/core';
  import _ from 'lodash';


  export default {
    name: 'Referrals',

    data: () => ({
      api: process.env.VUE_APP_ROOT_API,
      icons: {
        mdiHelpCircleOutline,
        mdiClose,
        add: mdiPlus
      },
      toggle: false,
      fullscreen: false,
      offsetTop: 0,
      selectedTab: 'Rodando',
      dialog: {
        toggle: false,
        headline: 'referrals.share.title',
        text: 'referrals.share.text',
      },
      installed: Capacitor.isNativePlatform(),
    }),

    computed: {
      views: sync('app/views'),
      view: sync('app/views@referrals'),
      items: sync('referrals/items'),
      help: get('help/sections'),
      user: get('user'),
      email: get('user/profile@email'),
      toast: sync('app/toast'),

      isEmpty () {
        return _.filter(this.items, (section) => {
          return section.items.length > 0;
        }).length == 0;
      },

      toolbarElevation () {
        return this.offsetTop >= 16 ? 2 : 0;
      },

      referralURL () {
        return 'https://mobees.com.br/dirija?email-indicacao='+this.email;
      },
    },

    watch: {
      $route (route) {
        const toggle = route.query.view=='referrals'||route.query.subview=='referrals';
        this.fullscreen = route.query.view=='referrals';
        this.toggle = toggle;
        if (toggle) {
          this.getData();
        }
      }
    },

    methods: {
      ...services,

      close () {
        this.$router.back();
      },

      onScroll (e) {
        this.offsetTop = e.target.scrollTop;
        if (!this.view.fullscreen&&this.offsetTop>5) {
          this.toggleFullscreen(true);
          this.$vuetify.goTo(0, {
            container: this.$refs.content,
            duration: 500,
            offset: 0,
            easing: 'easeInOutCubic'
          });
        }
      },

      // createKey (text) {
      //   const key = this.referralURL;
      //   return {
      //     text: typeof text != 'undefined' ? text.replace(/{{key}}/g, key) : '',
      //     key: key
      //   };
      // },

      progressCycles (p) {
        return Math.floor(p);
      },

      currentCycle (v, i) {
        return (v>i-1&&v<i) ? 0 : 100;
      },
      completeCycle (v, i) {
        return (v<i) ? 0 : 100;
      },

      addReferral (b){
        // move from state to prop sync
        this.dialog.toggle = b;
      },

      getData () {
        this.view.loading = true;

        const cpf = this.rawCPF(this.user.cpf);
        const token = this.user.auth.token;
        
        this.$api
          .get('/getreferrals/'+cpf+'/'+token+'/?format=json')
          .then(response => {
            console.log('getReferrals => ',response);
            if(response.data.retorno==200){
              const data = JSON.parse(response.data.list);
              const progress = data.shift();
              this.items.operating.items = [];
              this.items.waiting.items = [];
              for (let item in data) {
                if (data[item].status=='ACT'||data[item].status=='REA') {
                  this.items.operating.items.push({
                    name: data[item].name,
                    status: data[item].status,
                    progress: data[item].progress,
                  });
                }else{
                  this.items.waiting.items.push({
                    name: data[item].name,
                    status: data[item].status,
                    progress: data[item].progress,
                  });
                }
              }
              console.log(this.items.operating.items, this.items.waiting.items);

            }else if(response.data.retorno==401){
              this.getout();
              this.handleError(response.data.retorno, 'Sua sessão expirou...');
            }else{
              this.handleError(response.data.retorno, 'Erro desconhecido. Vamos investigar o que houve! 😊');
            }
          })
          .catch(error => {
            this.handleError(error);
          })
          .finally(() => {
            this.view.loading = false;
          });
      },
    },
    directives: {
      Scroll
    }
  }
</script>
